import { type ConstantType } from './types'

export const DATA_STATUS: ConstantType = {
  GENERATING: 2,
  DOWNLOAD: 1,
  FAILURE: 0,
}

export const DATA_STATUS_MAPPING: ConstantType = {
  [DATA_STATUS.GENERATING]: '生成中',
  [DATA_STATUS.DOWNLOAD]: '可下载',
  [DATA_STATUS.FAILURE]: '生成失败',
}

export const CONTENT = `
1. 业务端要提供一个soa接口获取要导出的数据:<br />
比如url="http://j37/tq-devops/api", service="storageActionLabelClassify", method="getList", param1=12, param2=1234<br />
返回的数据json格式中的data字段（为待导出的业务数据），支持分页数据<br /><br />
2. 队列名称：data_download_resource<br />
队列中数据格式：<br />
{<br />
"url": "XXXX", （业务端提供的接口的系统url 例如：http://j37/tq-devops/api）<br />
"service": "XXXX", （业务端提供的接口的service 例如：storageActionLabelClassify）<br />
"method": "XXXX", （业务端提供的接口的method 例如：getList）<br />
"userName": "XXXX", （当前用户的中文名 例如：张三）<br />
"loginName": "XXXX", （当前用户的登录名 例如：zhangsan）<br />
"sourceType": "XXXX", （生成的文件格式 目前只支持CSV 例如：CSV）<br />
"taskName": "XXXX", （任务名称， 例如：20200809数据导出）<br />
"taskId": "XXXX" （任务id(也可以是任意形式的字符串，平台会原样传入，能被自己提供的接口解析就行)，对应业务端提供的接口的param2 例如：1111）<br />
"uuid": "XXX", （文件下载的uuid全局唯一 例如：25ac495e-1038-4664-a5c5-f5d1ba3eb23a）<br />
"approval": "XXX" （文件下载是否需要审批 例如：true）<br />
}<br /><br />
3. 业务端提供的接口返回参数中必须含id属性，业务端提供的接口的param1就是拿到上一次接口返回值数组最后一个对象的id，首次传0，业务端soa接口查询数据按where id> param1 limit 1000 格式查询<br /><br />
4. 详细使用方式见飞书文档：<a href="https://o15vj1m4ie.feishu.cn/wiki/Q6mgwT09QiEAnkkkML7crpNtnKw" target="_blank">统一资源下载服务</a><br /><br />
  `
